export default "__VITE_ASSET__2f061005__"